module.exports = __webpack_public_path__ + "img/album19_06.f3d31146.jpg";